import script from "./workflow-review-sidepane-header-extra.vue?vue&type=script&setup=true&lang=ts"
export * from "./workflow-review-sidepane-header-extra.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__